var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1014_3243",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12L17.4683 12.5203L18.0464 12L17.4683 11.4797L17 12ZM7 11.3C6.6134 11.3 6.3 11.6134 6.3 12C6.3 12.3866 6.6134 12.7 7 12.7V11.3ZM13.1984 9.52031L16.5317 12.5203L17.4683 11.4797L14.1349 8.47969L13.1984 9.52031ZM16.5317 11.4797L13.1984 14.4797L14.1349 15.5203L17.4683 12.5203L16.5317 11.4797ZM17 11.3H7V12.7H17V11.3ZM21.6 12C21.6 17.3019 17.3019 21.6 12 21.6V24.4C18.8483 24.4 24.4 18.8483 24.4 12H21.6ZM12 21.6C6.69807 21.6 2.4 17.3019 2.4 12H-0.4C-0.4 18.8483 5.15167 24.4 12 24.4V21.6ZM2.4 12C2.4 6.69807 6.69807 2.4 12 2.4V-0.4C5.15167 -0.4 -0.4 5.15167 -0.4 12H2.4ZM12 2.4C17.3019 2.4 21.6 6.69807 21.6 12H24.4C24.4 5.15167 18.8483 -0.4 12 -0.4V2.4Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1014_3243)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSvg);
export default __webpack_public_path__ + "static/media/arrow_svg.7202f55b1f16865e5506d3b4dc43ac64.svg";
export { ForwardRef as ReactComponent };